module.exports = __webpack_public_path__ + "img/docimg.1a2bffbf.png";